import type { ClientResponse } from '@onhandtech/onhand-fe-shared/lib/api/v4/requests/get-requests'
import type { PayloadAction } from '@reduxjs/toolkit'
import { setNumberOfMissionsForRequestType } from 'redux/ayom/missions/actions'
import { selectedStatusOptionSelector } from 'redux/ayom/missions/selectors'
import { put, select } from 'redux-saga/effects'

export function* getRequestSetDataSaga(action: PayloadAction<ClientResponse | null>) {
  if (action.payload) {
    const statusOption = yield select(selectedStatusOptionSelector)
    yield put(
      setNumberOfMissionsForRequestType({
        statusOption,
        numberOfMissions: action.payload.pagination.total,
      }),
    )
  }
}
